import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextEditorComponent } from './text-editor.component';
import { DxHtmlEditorModule, DxPopupModule, DxColorBoxModule } from 'devextreme-angular';

import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {FormsModule} from '@angular/forms';

@NgModule({
    declarations: [
        TextEditorComponent
    ],
    imports: [
        CommonModule,
        DxHtmlEditorModule, DxPopupModule, DxColorBoxModule,
        MatButtonModule, MatSnackBarModule, FormsModule,
    ]
})
export class TextEditorModule { }
